import gql from "graphql-tag";
import {client} from "./client";
import {DeleteLayerByType} from "../../schema/DeleteLayerByType";
import {Mutation, FetchResult} from "../../types";

const getMutation = (type: string): any => ({
    mutation: gql`${DeleteLayerByType}`,
    variables: {
        type,
    },
});

export async function deleteLayerByType (fullUid: string) {
    try {
        const result: FetchResult<Mutation> = await client.mutate(getMutation(fullUid));
        const layer = result.data?.deleteLayerByType?.layer;
        await client.cache.reset();
        return {type: layer?.type};
    } catch (e) {
        console.error(e);
    }

}
